import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { compose } from 'recompose';
import { Formik, Form, Field } from 'formik';
import _orderBy from 'lodash/orderBy';
import propTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GenericStyledModal from '../../../../forms/pages/admin/modals/GenericStyledModal.modal';
import { AccentButtonMediumNunito, ButtonMediumNunito } from '../../../../../styledComponents/styles/Buttons.styled';
import { AccentButtonSpinner } from '../../../../../styledComponents/styles/spinner.styled';
import sBatchRemoveTags from './batchRemoveTags.scss';
import SubmissionTagDropDown from '../../../../../styledComponents/styles/SubmissionTagDropDown.styled';
import { getAvailableTags } from '../../../../../actions/formsActions';
import { removeBatchTravelerTags } from '../../../../../actions/reportsActions';
import { toast } from 'react-toastify';
import toastMessageStyles from '../../../../../sites/viaGlobal/components/toastMessage/toastMessage.scss';

export const enhance = compose(withStyles(sBatchRemoveTags, toastMessageStyles));

function BatchRemoveTravelerTags(props) {
  const dispatch = useDispatch();
  const availableTags = useSelector(state => state.forms.availableTags);
  const removeBatchTravelerTagsData = useSelector(state => state.reports.removeBatchTravelerTags);
  const customAliasTraveler = useSelector(state => state.profile.customAliases.alias_traveler.toLowerCase());
  const [saving, setSaving] = useState(false);
  const [alltagOptions, setAlltagOptions] = useState([]);
  const [tagSearchQuery, setTagSearchQuery] = useState('');
  const [travelerTag, setTravelerTag] = useState([]);

  useEffect(() => {
    dispatch(getAvailableTags(props.type));
  }, []);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      width: 'max-content',
      marginTop: '7px',
      marginLeft: '7px',
      padding: '4px 8px',
      gap: '4px',
      fontFamily: 'Open Sans',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '700',
      borderRadius: '4px',
      display: 'flex',
      color: state.data.textColor,
      backgroundColor: state.data.bgcolor,
    }),
    multiValue: (styles, state) => ({
      ...styles,
      backgroundColor: state.data.bgcolor,
    }),
    multiValueLabel: (styles, state) => ({
      ...styles,
      color: state.data.textColor,
      fontWeight: '700',
      fontSize: '14px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
    }),
    placeholder: styles => {
      return {
        ...styles,
        color: '#555',
        fontFamily: 'Open Sans',
        fontSize: '14px',
        fontStyle: 'italic',
        fontWeight: '400',
        lineHeight: '120%',
        letterSpacing: '0.21px',
      };
    },
  };
  const handleFilterOption = (option, rawInput) => {
    // Implement your custom filtering logic here.
    return option.label.toLowerCase().includes(rawInput.toLowerCase());
  };
  const handleTagInputChange = inputValue => {
    setTagSearchQuery(inputValue);
  };
  const handleSelectChange = newValue => {
    setTravelerTag(newValue?.length > 0 ? newValue : []);
  };

  useEffect(() => {
    const tagList = availableTags?.data?.data;
    const tags = tagList?.map(tag => {
      let tagLabel = tag.attributes.name;
      if (tag.attributes.emoji !== null && tag.attributes.emoji !== undefined) {
        tagLabel =
          tag.attributes.emoji
            .split(',')
            .join('')
            .trim() +
          ' ' +
          tag.attributes.name;
      }
      return {
        label: tagLabel,
        value: tag.id,
        name: tag.attributes.name.toLowerCase(),
        description: tag.attributes.description,
        bgcolor: tag.attributes.tag_color.bg_hex_code,
        textColor: tag.attributes.tag_color.font_hex_code,
      };
    });
    const sortedTags = _orderBy(tags, 'name', 'asc');

    const tagOptions = sortedTags?.filter(tag => {
      return handleFilterOption(tag, tagSearchQuery);
    });
    setAlltagOptions(tagOptions);
  }, [availableTags]);

  const resetForm = () => {
    setDefaultValues(() => {
      let values = {
        applicationSelected: [],
      };
      return values;
    });
  };

  useEffect(() => {
    if (removeBatchTravelerTagsData) {
      if (removeBatchTravelerTagsData.loading) {
        setSaving(true);
      }

      if (!removeBatchTravelerTagsData.loading && !!removeBatchTravelerTagsData.data) {
        if (removeBatchTravelerTagsData.data) {
          setSaving(false);
          resetForm();
          toast(removeBatchTravelerTagsData.data, {
            type: 'success',
            className: toastMessageStyles['successContainer'],
            toastClassName: toastMessageStyles['wrapper'],
            bodyClassName: toastMessageStyles['successBody'],
            progressClassName: toastMessageStyles['progress-bar'],
            position: 'bottom-right',
          });
          props.onClose(false);
        }
        if (removeBatchTravelerTagsData.error) {
          setSaving(false);
          resetForm();
          toast(removeBatchTravelerTagsData.error, {
            type: 'error',
            className: toastMessageStyles['failureContainer'],
            toastClassName: toastMessageStyles['wrapper'],
            bodyClassName: toastMessageStyles['failureBody'],
            progressClassName: toastMessageStyles['progress-bar'],
            position: 'bottom-right',
          });
          props.onClose(false);
        }
      }
    }
  }, [removeBatchTravelerTagsData]);

  const [defaultValues, setDefaultValues] = useState(() => {
    let values = {
      applicationSelected: [],
    };
    return values;
  });

  return (
    <>
      <GenericStyledModal
        showing={props.show}
        onClose={() => {
          props.onClose(false);
        }}
        width="700px"
        header={`Remove ${props.type} Tags`}
      >
        <div className={sBatchRemoveTags['modal-body']}>
          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={defaultValues}
            validate={(values, index) => {
              // const errors = {};
              // if (values.status === '') {
              //   errors.status = 'Status required';
              // }
              // return errors;
            }}
            onSubmit={values => {
              const travelerTagIds = travelerTag.map(tag => {
                return tag.value;
              });
              const submitValues = {
                tag_ids: travelerTagIds,
                taggable_ids: props.selectedUsers,
                type: props.type,
              };
              setSaving(true);
              dispatch(removeBatchTravelerTags(submitValues, props.type));
              props.setSelectedTravelers();
            }}
          >
            {({ values, handleSubmit, errors }) => (
              <Form>
                <div className={sBatchRemoveTags.heading}>
                  <p>
                    You are about to remove tags from {props.selectedUsers.length} {customAliasTraveler}.
                  </p>
                </div>
                <div className={sBatchRemoveTags.row}>
                  <div className={sBatchRemoveTags.item}>
                    <Field name="tags">
                      {({ form }) => (
                        <div style={{ width: '450px', margin: 'auto' }}>
                          <SubmissionTagDropDown
                            key={`action_traveler_tag`}
                            aria-label="Traveler Tag"
                            placeholder={'Type to select tag'}
                            id="traveler_tag"
                            options={alltagOptions}
                            handleInputChange={handleTagInputChange}
                            handleSelectChange={handleSelectChange}
                            tagSearchQuery={tagSearchQuery}
                            customStyles={customStyles}
                            width="100%"
                            showCreateTagOption={false}
                          />
                        </div>
                      )}
                    </Field>
                  </div>
                </div>

                <div className={sBatchRemoveTags.footer}>
                  <div className={sBatchRemoveTags.buttonContainer}>
                    <div className={sBatchRemoveTags['button-content']}>
                      <ButtonMediumNunito
                        type={'button'}
                        onClick={() => props.onClose(false)}
                      >
                        Cancel
                      </ButtonMediumNunito>
                    </div>
                    <div className={sBatchRemoveTags['button-content']}>
                      <AccentButtonMediumNunito
                        disabled={saving || travelerTag.length == 0}
                        aria-label="Remove Tags"
                        type="submit"
                      >
                        {saving ? <AccentButtonSpinner displayText="Loading ..." /> : 'Remove Tags'}
                      </AccentButtonMediumNunito>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </GenericStyledModal>
    </>
  );
}

BatchRemoveTravelerTags.propTypes = {
  show: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
};

BatchRemoveTravelerTags.propTypes = {
  show: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
};

export default enhance(BatchRemoveTravelerTags);
